import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralComponent } from 'src/app/shared/general.component';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua042-card-II',
    templateUrl: './qua042-card-II.component.html'
})

export class Qua042CardIIComponent extends GeneralComponent implements OnInit {
    public show: boolean = true;
    public formulario?: FormGroup;
    public readyOnlyGeracao?: boolean;
    @Output() objEt004 = new EventEmitter();
    @Output() mkCalc = new EventEmitter();
    @Output() mkCalcI = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected generalService: GeneralService) {
        super('Dados de Tratamento', false);
        this.formulario = this.formBuilder.group({
            controle_analise_et004: [null, []],
            tipo_tratamento: [null, []],
            inicio_tratamento_data: [null, []],
            inicio_tratamento_hora: [null, []],
            termino_tratamento_data: [null, []],
            termino_tratamento_hora: [null, []],
            duracao_atividade_tratamento_h: [null, []]
        });
    }

    ngOnInit(): void {
        this.readyOnlyGeracao = true;
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    async getDataEt004(): Promise<void> {
        this.objEt004.emit();
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async makeCalculationsI(): Promise<void> {
        this.mkCalcI.emit();
    }
}
